import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { SiteContentProvider } from "@/contexts/SiteContentContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLeads from "@/pages/AdminLeads";
import AdminBlog from "@/pages/AdminBlog";
import AdminBlogEditor from "@/pages/AdminBlogEditor";
import AdminMedia from "@/pages/AdminMedia";
import AdminSite from "@/pages/AdminSite";
import AdminPush from "@/pages/AdminPush";
import AdminOgPreview from "@/pages/AdminOgPreview";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminEmail from "@/pages/AdminEmail";
import AdminBilling from "@/pages/AdminBilling";
import Imprint from "@/pages/Imprint";
import Privacy from "@/pages/Privacy";
import PrivacyBanner from "@/components/PrivacyBanner";
import PageviewTracker from "@/components/PageviewTracker";
import ScrollToTop from "@/components/ScrollToTop";
import BlogList from "@/pages/BlogList";
import BlogDetail from "@/pages/BlogDetail";
import ServiceDetail from "@/pages/ServiceDetail";
import ProtectedRoute from "@/pages/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <SiteContentProvider>
            <AuthProvider>
              <BrowserRouter>
                <ScrollToTop />
                <PageviewTracker />
                <PrivacyBanner />
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/blog" element={<BlogList />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/services/:slug" element={<ServiceDetail />} />
                  <Route path="/impressum" element={<Imprint />} />
                  <Route path="/imprint" element={<Imprint />} />
                  <Route path="/datenschutz" element={<Privacy />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/leads"
                    element={
                      <ProtectedRoute>
                        <AdminLeads />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/billing"
                    element={
                      <ProtectedRoute>
                        <AdminBilling />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/blog"
                    element={
                      <ProtectedRoute>
                        <AdminBlog />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/blog/new"
                    element={
                      <ProtectedRoute>
                        <AdminBlogEditor />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/blog/edit/:id"
                    element={
                      <ProtectedRoute>
                        <AdminBlogEditor />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/site"
                    element={
                      <ProtectedRoute>
                        <AdminSite />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/media"
                    element={
                      <ProtectedRoute>
                        <AdminMedia />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/push"
                    element={
                      <ProtectedRoute>
                        <AdminPush />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/og"
                    element={
                      <ProtectedRoute>
                        <AdminOgPreview />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/analytics"
                    element={
                      <ProtectedRoute>
                        <AdminAnalytics />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/email"
                    element={
                      <ProtectedRoute>
                        <AdminEmail />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </BrowserRouter>
              <Toaster position="top-right" richColors />
            </AuthProvider>
          </SiteContentProvider>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
